export default __webpack_public_path__ + "static/media/330_store05-jp-mobile.f87e63be.png";